import(/* webpackMode: "eager" */ "/vercel/path0/components/markdown/Hide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideResetButton"] */ "/vercel/path0/components/markdown/HideResetButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideUsageGuide"] */ "/vercel/path0/components/markdown/HideUsageGuide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/navigation/LoginDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/data/study/licence/01-01-house-quiz/components/HouseQuiz.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/data/study/licence/01-02-apartments-quiz/components/ApartmentsQuiz.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/data/study/licence/01-03-publicbuildings-quiz/components/PublicQuiz.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/data/study/licence/05-01-documents-quiz/components/DocumentsQuiz.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
